import React from "react";
import { Route } from "react-router-dom";
import { useSelector } from "react-redux";
import { NotAuthorized } from "../components/pages";
import Page from "./Page";

function ProtectedRoute({ component: Component, ...rest }) {
  const isAuth = useSelector((state) => state.user.isAuth);
  const isFetching = useSelector((state) => state.user.isFetching);

  return (
    <Route
      {...rest}
      render={(props) => {
        if (isFetching) {
          return <div></div>;
        } else if (isAuth) {
          return (
            <Page title={`Hazardous Waste Tracking System${rest.title ? (": " + rest.title) : ""}`}>
              <Component {...props} />
            </Page>
          );
        } else {
          return <NotAuthorized />;
        }
      }}
    />
  );
}

export default ProtectedRoute;
